import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "includeDeleted"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import playlistKey from './queryKeys';
function useFetchPlaylistDetails(_ref) {
  var id = _ref.id,
    _ref$includeDeleted = _ref.includeDeleted,
    includeDeleted = _ref$includeDeleted === void 0 ? false : _ref$includeDeleted,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  var queryKey = playlistKey.singlePlaylistDetails(id);
  function fetchMyPlaylistDetails() {
    return _fetchMyPlaylistDetails.apply(this, arguments);
  }
  function _fetchMyPlaylistDetails() {
    _fetchMyPlaylistDetails = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('get', "/api/playlists/".concat(id), {
              includeDeleted: includeDeleted
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchMyPlaylistDetails.apply(this, arguments);
  }
  return useQuery(_objectSpread({
    queryKey: queryKey,
    queryFn: fetchMyPlaylistDetails,
    staleTime: 5 * 60 * 1000,
    retry: function retry(count, data) {
      if ([403, 404].includes(data === null || data === void 0 ? void 0 : data.status)) {
        return false;
      }
      return true;
    }
  }, queryOptions));
}
export default useFetchPlaylistDetails;